import Component from '../abstracts/Component';
import ScrollMagic from 'scrollmagic';
// import 'debug.addIndicators';
export default class ProductHeadComponent extends Component {

	get SELECTORS() {
    return {
      main: '.c-shop-the-look-module',

    }
  }

  get CLASSES() {
    return {  
    }
  }

  constructor() {
    super()
    this.controller = new ScrollMagic.Controller();
    this.scene;
  }


  getLastImageHeight() {
    
    const imgHeight = $('.product-images .media-container:last-of-type').outerHeight()
    const discoverLook = $('.discover-look');

    discoverLook.css({
      'top': 'calc(100% - '+imgHeight+'px)',
      'display': 'block'
    })
    

  }

  setPositions() {
    const customOffset = this.$matchMedia(null, 'lg') ? '-30' : '0';
    let setDuration;
    setDuration = document.querySelector('.c-shop-the-look-module .carousel').offsetHeight - document.querySelector('.look-image').offsetHeight 


    // console.log('duration: ' + setDuration)
    // console.log('carousel: ' + document.querySelector('.c-shop-the-look-module .carousel').offsetHeight)
    // console.log('lokk: ' + document.querySelector('.look-image').offsetHeight)
    const swatches =  document.querySelector('.look-image').offsetTop

    this.bindScroll(customOffset, setDuration, swatches)
  }

  bindScroll(customOffset, setDuration, swatches) {
    this.scene = new ScrollMagic.Scene({triggerElement: ".look-image", duration: setDuration - customOffset, triggerHook: 0, offset: customOffset - document.querySelector('.shop-the-look-module-title').offsetHeight})
            .setPin(".look-image")
            // .addIndicators()
            .addTo(this.controller);
  }

  render() {

    const component = document.querySelector(this.SELECTORS.main);
    if (component === null) return;

    if (this.$matchMedia(null, 'md')) {
      this.setPositions()
    }
    
    $(window).on('resize ', () => {
      if (this.scene) {
        this.scene.destroy(true);
      }
      
      if (this.$matchMedia(null, 'md')) {
        this.setPositions()
      }
    })

  }
}
